/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./deleteRecord.defs.js";
export { main as default } from "./deleteRecord.defs.js";
